// React import
import React from 'react';
import { connect } from "react-redux";
// Components import
import TokenAnalyzerWalletStatsItem from "../TokenAnalyzerWalletStatsItem";
import TokenAnalyzerWalletStatsUpgrade from "../TokenAnalyzerWalletStatsUpgrade";
// Styles imports
import './TokenAnalyzerWalletStats.css';
import '../../util.css'
// Import consts
import { FREE } from "../../consts/consts";

class TokenAnalyzerWalletStats extends React.Component {

    constructor(props) {
        super(props);
    }

    render () {

        const { tokenWallets } = this.props.tokenAnalyzer;
        const { ai_level, subscription } = this.props.userData;

        let upgradeBlock = null;

        if(subscription === FREE) {
            upgradeBlock = (<TokenAnalyzerWalletStatsUpgrade/>);
        }

        return(
            <div className={"token-analyzer__tokens-stats-block noselect"}>
                {tokenWallets.map((tokenWallet, index) =>
                    <TokenAnalyzerWalletStatsItem
                        key={index}
                        index={index}
                        address={tokenWallet.address}
                        shortAddress={tokenWallet.shortAddress}
                        indicator={tokenWallet.indicator}
                        bought={tokenWallet.bought}
                        sold={tokenWallet.sold}
                        profit={tokenWallet.profit}
                        pnl={tokenWallet.pnl}
                        firstTx={tokenWallet.firstTx}
                        tradeTime={tokenWallet.tradeTime}
                        buys={tokenWallet.buys}
                        sells={tokenWallet.sells}
                        aiLevel={ ai_level }
                    />
                )}
                {upgradeBlock}
            </div>
        );
    }

}

const mapStateToProps = ({ tokenAnalyzer, userData }) => {
    return { tokenAnalyzer, userData };
};

export default connect(mapStateToProps)(TokenAnalyzerWalletStats);